import React from 'react';
import { Instagram, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-neutral-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* About Us */}
          <div>
            <h3 className="text-lg font-serif mb-4 tracking-wide text-neutral-800">About Us</h3>
            <p className="text-sm text-neutral-600 leading-relaxed mb-4">
              GURIVA™ | We are a brand that celebrates people and moments through thoughtful gifts that have a unique story to tell. Shop ready to ship luxury festive gifts for your friends & family or luxury corporate high end gifts for your clients through one of the best gifting sites in India. Also build customized corporate or personal gift for your special event through our custom & bespoke design service.
            </p>
            <p className="text-sm text-neutral-600 leading-relaxed">
              We offer PAN India Gift Delivery
            </p>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-lg font-serif mb-4 tracking-wide text-neutral-800">Customer Service</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/search" className="text-sm text-neutral-600 hover:text-neutral-900 transition-colors">
                  Search
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="text-sm text-neutral-600 hover:text-neutral-900 transition-colors">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-neutral-600 hover:text-neutral-900 transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-neutral-600 hover:text-neutral-900 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-sm text-neutral-600 hover:text-neutral-900 transition-colors">
                  Refund policy
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-neutral-600 hover:text-neutral-900 transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-sm text-neutral-600 hover:text-neutral-900 transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-sm text-neutral-600 hover:text-neutral-900 transition-colors">
                  Shipping Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="text-lg font-serif mb-4 tracking-wide text-neutral-800">Join Our World</h3>
            <p className="text-sm text-neutral-600 mb-4">
              Unique Gifts Update And Guriva Happenings Straight to Your Inbox.
            </p>
            <div className="flex gap-4 mb-6">
              <a
                href="https://www.instagram.com/guriva.gifts/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-neutral-600 hover:text-neutral-900 transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href="mailto:preity@guriva.com"
                className="text-neutral-600 hover:text-neutral-900 transition-colors"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-neutral-200 text-center">
          <p className="text-sm text-neutral-600">
            © Guriva - House of Gifting. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;